import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

import TopNav from '../components/topnav/TopNav';
import SideNav from '../components/sidenav/SideNav';
import AuthPage from './auth/AuthPage';
import Home from './home/Home';
import AI from './ai/AI';
import Character from './character/Character';
import CatalogRouter from './catalog/CatalogRouter';
import Gallery from './gallery/Gallery';
import Account from './account/Account';
import Help from './help/Help';
import Status from './help/Status';
import LegalDocument from './legal/LegalDocument';

import './app.css';

const App = ({ authViewVisible, admin, location, user }) => {
  const adminUser = admin && admin.user;
  const isHomeRoute = location && location.pathname === '/';
  const isLegalRoute =
    location && (location.pathname === '/terms-of-use' || location.pathname === '/privacy-policy');
  const isGuestLandingRoute = Boolean(isHomeRoute && !user);
  const useLandingShellLayout = Boolean(isHomeRoute || isLegalRoute);
  const hideSideNav = Boolean(isHomeRoute || isLegalRoute);
  const useLandingContentLayout = Boolean(isHomeRoute || isLegalRoute);
  const isAuthenticated = Boolean(user && user.id);
  const redirectToHomeIfGuest = (routeProps, Component) => (
    isAuthenticated ? <Component {...routeProps} /> : <Redirect to="/" />
  );

  if (adminUser) {
    return <Redirect to="/admin" />;
  }

  return (
    <div className={`app-shell${useLandingShellLayout ? ' app-shell--landing' : ''}`}>
      {authViewVisible && <AuthPage />}
      {!isGuestLandingRoute && !isLegalRoute && <TopNav />}
      <div className={`app-body${useLandingShellLayout ? ' app-body--landing' : ''}`}>
        {!hideSideNav && <SideNav />}
        <main className={`app-content${useLandingContentLayout ? ' app-content--landing' : ''}`}>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/ai" render={(routeProps) => redirectToHomeIfGuest(routeProps, AI)} />
            <Route
              path="/character"
              render={(routeProps) => redirectToHomeIfGuest(routeProps, Character)}
            />
            <Route
              path="/gallery"
              render={(routeProps) => redirectToHomeIfGuest(routeProps, Gallery)}
            />
            <Route
              path="/catalog"
              render={({ location: routeLocation }) => (
                <Redirect
                  to={{
                    pathname: routeLocation.pathname.replace(/^\/catalog/, '/templates'),
                    search: routeLocation.search,
                    state: routeLocation.state,
                  }}
                />
              )}
            />
            <Route
              path="/templates"
              render={(routeProps) => redirectToHomeIfGuest(routeProps, CatalogRouter)}
            />
            <Route
              path="/account"
              render={(routeProps) => redirectToHomeIfGuest(routeProps, Account)}
            />
            <Route path="/help" component={Help} />
            <Route path="/status" component={Status} />
            <Route
              path="/terms-of-use"
              render={() => <LegalDocument type="terms" />}
            />
            <Route
              path="/privacy-policy"
              render={() => <LegalDocument type="privacy" />}
            />
            <Redirect to="/" />
          </Switch>
        </main>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  authViewVisible: state.auth.authViewVisible,
  user: state.auth.user,
  admin: state.auth.admin,
});

export default withRouter(connect(mapStateToProps)(App));
